export default {
  buttons: {
    more_payment_methods: 'Flere betalingsmetoder',
  },
  toasts: {
    processing: 'Behandler betalingsoplysninger. Vi giver dig besked, når behandlingen er afsluttet.',
    failed: 'Betalingsoplysningerne kunne ikke behandles. Prøv en anden betalingsmetode.',
    failed_to_load: 'Betalingsformularen kunne ikke indlæses. Genindlæs siden, og prøv igen.',
    failed_to_save_payment_method: 'Betalingsmetoden kunne ikke gemmes',
    failed_to_create_checkout_session: 'Noget gik galt, prøv igen',
  },
};
